const namespace = 'Courier';

export const REQUEST_TEMPLATES = `${namespace}/REQUEST_TEMPLATES`;
export const RECEIVE_TEMPLATES_SUCCESS = `${namespace}/RECEIVE_TEMPLATES_SUCCESS`;
export const RECEIVE_TEMPLATES_FAILURE = `${namespace}/RECEIVE_TEMPLATES_FAILURE`;
